
<template>
  <eye-exam-card
    class="medical-record-exam-view"
    :title="title"
    :patient-id="patientId"
    :record-id="recordId"
    :exam-id="examId"
    :inputs="data"
    :date="date"
    @edit="$emit('edit')"
    :show-edit-button="showEditButton"
  >
    <st-data-display label="" :value="data.content">
      <div v-html="data.content" />
    </st-data-display>
  </eye-exam-card>
</template>

<script>
import EyeExamCard from '../ophtalmology/EyeExamCard.vue';

export default {
  name: 'DefaultView',
  components: {
    EyeExamCard,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    patientId: {
      type: String,
      required: false,
    },
    recordId: {
      type: String,
      required: false,
    },
    examId: {
      type: String,
      required: false,
    },
    date: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
    showEditButton: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";
</style>
